import { Link } from "react-router-dom";
import { Check, Ban, Pencil, Package } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { StatusBadge, eurOr } from "@/lib/wh";

export function ItemRow({ it, selected, onSelect, onAction, canWrite }) {
  const photo = it.photos?.[0];
  return (
    <li className="flex items-center gap-3 py-3" data-testid={`wh-item-${it.code}`}>
      <input type="checkbox" className="h-4 w-4 shrink-0" checked={selected} onChange={() => onSelect(it.id)} aria-label="Seleziona" data-testid={`wh-select-${it.code}`} />
      <Link to={`/magazzino/articoli/${it.id}`} className="flex items-center gap-3 min-w-0 flex-1" data-testid={`wh-open-${it.code}`}>
        {photo ? <img src={fileUrl(photo)} alt="" className="h-14 w-14 rounded-xl object-cover border shrink-0" loading="lazy" />
          : <div className="h-14 w-14 rounded-xl border bg-[var(--surface-2)] grid place-items-center shrink-0"><Package className="h-5 w-5 text-[var(--muted)]" /></div>}
        <div className="min-w-0">
          <div className="flex items-center gap-2 flex-wrap"><span className="font-mono text-xs font-semibold">{it.code}</span><StatusBadge status={it.status} /></div>
          <p className="text-sm font-medium truncate">{it.description || <span className="text-[var(--muted)] italic">Senza descrizione</span>}</p>
          <p className="text-xs text-[var(--muted)] truncate">{it.lot_name || "Senza lotto"}{it.category ? ` · ${it.category}` : ""} · {it.qty_available}/{it.quantity} pz · {eurOr(it.sale_price)}</p>
        </div>
      </Link>
      {canWrite && (
        <div className="flex shrink-0">
          <button onClick={() => onAction(it, "sell")} disabled={!it.qty_available} className="btn-ghost text-emerald-700 disabled:opacity-30" aria-label="Venduto" data-testid={`wh-sell-${it.code}`}><Check className="h-5 w-5" /></button>
          <button onClick={() => onAction(it, "remove")} disabled={!it.qty_available} className="btn-ghost text-red-600 disabled:opacity-30" aria-label="Rimosso" data-testid={`wh-remove-${it.code}`}><Ban className="h-5 w-5" /></button>
          <Link to={`/magazzino/articoli/${it.id}?edit=1`} className="btn-ghost" aria-label="Modifica" data-testid={`wh-edit-${it.code}`}><Pencil className="h-5 w-5" /></Link>
        </div>
      )}
    </li>
  );
}
